<template>
  <div class="user-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t('invited_users.title') }}</h2>
      <b-button variant="primary" @click="createUser">
        <i class="fas fa-plus mr-2"></i>{{ $t('invited_users.invite_button') }}
      </b-button>
    </div>

    <CrudTable
      :columns="fields"
      :data-sources="users"
      :pagination="paginationInfo"
      :loader="isLoading"
      list-url="/admin/invite-users"
      @search="handleSearch"
      @filter="handleFilter"
      @refresh="fetchUsers"
    >
      <!-- Name Column -->
      <template #cell(full_name)="data">
        <div class="d-flex align-items-center">
          <div>
            <div class="text-muted small">{{ data.item.email || 'N/A' }}</div>
          </div>
        </div>
      </template>

      <!-- Role Column -->
      <template #cell(roles)="data">
        <div>
          {{ data.item.roles || 'N/A' }}
        </div>
      </template>

      <!-- Status Column -->
      <template #cell(invitation_status)="data">
        <div>
          {{ data.item.invitation_status || 'N/A' }}
        </div>
      </template>


    </CrudTable>

  </div>
</template>

<script>
import { request } from "@/Util/Request";
import CrudTable from "@/components/CrudTable.vue";

export default {
  name: 'InviteUserList',
  components: {
    CrudTable
  },

  data() {
    return {
      users: [],
      isLoading: false,
      showDeleteModal: false,
      selectedUser: null,
      currentPage: 1,
      perPage: 10,
      sortBy: 'created_at',
      sortDesc: true,

      filters: {
        search: '',
        role: null,
        status: null
      },
      fields: [
        { key: 'roles', label: this.$t('user.table_header_role'), sortable: true, sortDirection: 'asc' },
        { key: 'phone', label: this.$t('user.table_header_phone'), sortable: true, sortDirection: 'asc' },
        { key: 'invitation_status', label: this.$t('user.table_header_status'), sortable: true, sortDirection: 'asc' },
        { key: 'expires_at', label: this.$t('invited_users.table_header_expires_at'), sortable: true, sortDirection: 'asc' },
      ],
      roleOptions: [],
      statusOptions: [
        { value: null, text: this.$t('user.status_all') },
        { value: 'active', text: this.$t('user.status_active') },
        { value: 'inactive', text: this.$t('user.status_inactive') }
      ],
      paginationInfo: {
        from: 0,
        to: 0,
        total: 0
      }
    }
  },
  async created() {
    await this.fetchRoles();
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.label
      };
    },
    getInitials(name) {
      if (!name) return '';
      return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase();
    },
    async fetchRoles() {
      try {
          const response = await request({
              method: "get",
              url:'dropdowns/roles'});

        if (response.status === 200) {
          this.roleOptions = response.data.map(role => ({
            id: role.id,
            label: role.label
          }));
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
        this.roleOptions = [];
      }
    },
    handleSearch(search) {
      this.filters.search = search;
      this.currentPage = 1;
      this.fetchUsers();
    },
    handleFilter(filter) {
      this.filters = { ...this.filters, ...filter };
      this.currentPage = 1;
      this.fetchUsers();
    },
    createUser() {
      this.$router.push('/admin/users/invite');
    },
    
    async fetchUsers() {
      try {
        this.isLoading = true;
        const response = await request({
          method: "get",
          url:'/admin/invite-users',
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            sort_by: this.sortBy,
            sort_direction: this.sortDesc ? 'desc' : 'asc',
            search: this.filters.search || ''
          }
        });
        this.users = response.data || [];
        this.paginationInfo = {
          from: response.data.meta?.from || 0,
          to: response.data.meta?.to || 0,
          total: response.data.meta?.total || 0
        };
      } catch (error) {
        console.error('Error fetching users:', error);
        this.users = [];
        this.paginationInfo = {
          from: 0,
          to: 0,
          total: 0
        };
      } finally {
        this.isLoading = false;
      }
    },
  }
}
</script>

<style scoped>


.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
</style>
